import api from "./Api";

class AgenciaBoletoLicencaService {
  GetAgenciaBoletoLicenca(payload) {
    return api.get("/v1/agenciaboletolicenca/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAgenciaBoletoLicenca(payload) {
    return api.post("/v1/agenciaboletolicenca/", payload).then((response) => {
      return response.data;
    });
  }

  PutAgenciaBoletoLicenca(payload) {
    return api.put("/v1/agenciaboletolicenca/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAgenciaBoletoLicenca(payload) {
    return api
      .delete("/v1/agenciaboletolicenca/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetAgenciaBoletoLicencaOData(payload) {
    return api.get("/OData/agenciaboletolicenca" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AgenciaBoletoLicencaService();
